export const JOB_ROLE_VALUES = [
  'Marketing',
  'Brand Strategy',
  'Digital Marketing',
  'Social Media Marketing',
  'Influencer Marketing',
  'Communications / PR',
  'Media Planning',
  'Media Buying',
  'Advertising / Creative',
  'Programmatic / Ad Tech',
  'Consumer Insights / Market Research',
  'Data & Analytics',
  'Audience Strategy / Planning',
  'Account Management',
  'Strategy / Consulting',
  'Product / Innovation',
  'Sales / Business Development',
  'C-Level / Leadership (CMO, CEO, ecc.)',
  'Other',
] as const;

export type JobRole = (typeof JOB_ROLE_VALUES)[number];

export const JOB_ROLE_OPTIONS = JOB_ROLE_VALUES.map((value) => ({
  label: value,
  value,
}));
